import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SettingsService } from '../../../core/settings/settings.service';
import { map } from 'rxjs/operators';
import { TopNavbarComponent } from '@app/shared/components/top-navbar/top-navbar.component';
import { LoyaltyClubHeaderComponent } from '@app/shared/components/loyalty-club-header/loyalty-club-header.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LoyaltyClubFooterComponent } from '@app/shared/components/loyalty-club-footer/loyalty-club-footer.component';
import { AsyncPipe } from '@angular/common';
import { AlertComponent } from '@app/shared/components/alert/alert.component';

@Component({
  selector: 'app-profile-destroy-finish',
  templateUrl: './profile-destroy-finish.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TopNavbarComponent,
    LoyaltyClubHeaderComponent,
    TranslatePipe,
    LoyaltyClubFooterComponent,
    AsyncPipe,
    AlertComponent,
  ],
})
export class ProfileDestroyFinishComponent {
  protected loyaltyClubName$ = this.settingsService.getSettingsOnce()
    .pipe(
      map(settings => settings.name),
    );

  constructor(private settingsService: SettingsService) { }
}
